Vue.component("MpEquipmentLogoCarousel", {
    props: {
        word: String,
        type: String,
        categoryFullList: Array,
        selectedCategories: Array,
        // moduleName: String,
    },
    data: function() {
        return {
            SOURCE_URL: '/equipment/filterEquipmentsInModule',
            RESPONSE_OK: 'OK',
            RESPONSE_KO: 'KO',

            TYPE_FULLWIDTH: 'fullwidth',
            TYPE_SIDEBAR: 'sidebar',

            equipmentList: [],

            carousel: null,

            swiperInitialized: false,
            isInitialized: false,
        };
    },
    computed: {

        dataEquipmentsModule: function() {
            if (!this.isInitialized) { 
                return;
            }

            return Serializer.serialize({
                'searchingWords': this.word,
                'searchingCategories': this.selectedCategories,
            });
        },

    },
    methods: {

        initSwiper: function() {

            if (this.swiperInitialized) {
                this.carousel.update();
                return;
            }

            this.swiperInitialized = true;

            this.carousel = new Swiper(this.$refs.carousel, {
                slidesPerView: 'auto',
                freeMode: true,
                autoplay: {
                    delay: 2000,
                    disableOnInteraction: false,
                },
                centerInsufficientSlides: true,
                spaceBetween: 40,
            });
        },

        onEquipmentsLoaded: function(response) {
            if (response.data.result == this.RESPONSE_OK) {
                this.equipmentList = response.data.equipments;
            }

            Vue.nextTick(this.initSwiper);
        },

        loadEquipments: function() {
            axios
            .post(this.SOURCE_URL, this.dataEquipmentsModule)
            .then(this.onEquipmentsLoaded)
            .catch(function(error) {
                console.log(error);
            });
        },

        init: function() {
            this.isInitialized = true;
            this.loadEquipments();
        }
    },

    mounted: function() {
        this.init();
    },

    updated: function() {},

    created: function() {
        MpEventBus.$on(EVENT_BULLETIN_SEARCH, this.loadEquipments);
    },

    destroyed: function() {
        MpEventBus.$off(EVENT_BULLETIN_SEARCH, this.loadEquipments);
    },

    template: '\
    <article class="equipment-logo-carousel swiper-container u-mt-xl" ref="carousel" v-if="type==TYPE_FULLWIDTH">\
        <div class="swiper-wrapper">\
            <div class="equipment-logo-carousel__slide swiper-slide" v-for="equipment in equipmentList">\
                <a :href="equipment.link" :title="equipment.resume">\
                    <img :src="equipment.logo" :alt="equipment.company" :title="equipment.company">\
                </a>\
            </div>\
        </div>\
    </article>\
    <div class="equipment-logo-list" v-else>\
        <div class="row justify-content-around">\
            <div class="col-5" v-for="equipment in equipmentList">\
                <a :href="equipment.link" :title="equipment.resume">\
                    <img :src="equipment.logo" :alt="equipment.company" :title="equipment.company">\
                </a>\
            </div>\
        </div>\
    </div>',
});
